import React, { useState, useEffect, useContext } from "react";
import UserDetails from "components/userProfile/UserDetails";
import WalletDetails from "components/userProfile/WalletDetails";
import ScoreDetails from "components/userProfile/ScoreDetails";
import Messages from "components/userProfile/Messages";
import PaginatedItems from "components/common/Pagination";
import { connection } from "utils/apiConnection.ts";
import { useParams } from "react-router";
import Loader from "utils/Loader";
import WithAuthentication from "Authentication/AuthenticationContext.ts";

import "./UserProfile.scss";
const UserProfile = () => {
  const auth = useContext(WithAuthentication);
  const [user, setUser] = useState({
    id: "",
    fullname: "",
    codemelli: "",
    address: "",
    email: "",
    birthdayts: "",
    coverImg: "",
    coverImgId: "",
  });
  const [messages, setMessages] = useState([]);
  const [scores, setScores] = useState([]);
  const [wallet, setWallet] = useState([]);
  const [coin, setCoin] = useState(0);
  const [loader, setLoader] = useState(true);
  async function apihandler() {
    let userId = auth.userInfo.id;
    let keyvalues = {
      userId,
    };
    let result = await connection("getuserinfo", keyvalues);
    setUser({
      id: result.result.id,
      fullname: result.result.fullname,
      codemelli: result.result.codemelli,
      address: result.result.address,
      mobile: result.result.mobile,
      email: result.result.email,
      birthdayts: result.result.birthdayts,
      coverImg: result.result.coverImg,
      coverImgId: result.result.coverImgId,
    });
    setCoin(result.result.current_coin);
    setWallet(result.result.settings);
    setScores(result.result.pointRecords);
    setMessages(result.result.notifications);
    setLoader(false);
  }
  useEffect(() => {
    apihandler();
  }, []);

  return (
    <>
      {loader ? <Loader /> : ""}
      <div className="userProfile">
        <UserDetails user={user} setUser={setUser} setLoader={setLoader} />
        <WalletDetails
          wallet={wallet}
          setWallet={setWallet}
          setLoader={setLoader}
          user={user}
          coin={coin}
        />
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="pills-scores-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-scores"
              type="button"
              role="tab"
              aria-controls="pills-scores"
              aria-selected="true"
            >
              اطلاعات امتیاز
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="pills-messages-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-messages"
              type="button"
              role="tab"
              aria-controls="pills-messages"
              aria-selected="false"
            >
              پیام ها
            </button>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-scores"
            role="tabpanel"
            aria-labelledby="pills-scores-tab"
          >
            {scores.length > 0 ? (
              <PaginatedItems
                itemsPerPage={8}
                items={scores}
                TheComponent={ScoreDetails}
              />
            ) : (
              <div style={{ textAlign: "center", marginBottom: "50px" }}>
                اطلاعات امتیازی وجود ندارد.
              </div>
            )}
          </div>
          <div
            class="tab-pane fade"
            id="pills-messages"
            role="tabpanel"
            aria-labelledby="pills-messages-tab"
          >
            {messages.length > 0 ? (
              <PaginatedItems
                itemsPerPage={5}
                items={messages}
                TheComponent={Messages}
              />
            ) : (
              <div style={{ textAlign: "center", marginBottom: "50px" }}>
                پیامی وجود ندارد.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfile;
